<template>
  <div class="wrapper">
    <side-bar>
      <sidebar-link to="/admin/overview">
        <p><i class="bi bi-house-fill"></i>Inicio</p>
      </sidebar-link>
     
      <template slot="bottom-links">
        <a
          href="https://www.ticktaps.com/"
          class="d-flex justify-content-center text-white"
          @click.prevent="openLink"
          style="cursor: pointer"
          ><p style="font-size: 0.8rem">Desarrollado por Ticktaps</p></a
        >
      </template>
      <mobile-menu></mobile-menu>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar"> </dashboard-content>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from './TopNavbar.vue'
import DashboardContent from './Content.vue'
import MobileMenu from './MobileMenu.vue'

export default {
  name: 'DashboardLayout',
  components: {
    TopNavbar,
    DashboardContent,
    MobileMenu
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    },
    openLink() {
      window.open('https://www.ticktaps.com/', '_blank')
    }
  }
}
</script>
